<template>
    <div class="relative inline-flex gap-4 items-center w-[20rem] sm:w-[25vw] h-20 sm:h-20 pr-2 border bg-white rounded-lg">
  
      <div class="ml-3 sm:w-16 sm:h-16 w-11 h-11 rounded-lg overflow-hidden flex items-center justify-center flex-shrink-0 bg-gray-100" @click="openRateOrders">
          <NuxtImg
            :src="thumbnail"
            class="w-full h-full object-cover"
            @error="setDefaultImage"
            alt="rate order icon"
            title="rate order"
        />
        </div>
  
  
      <div class="flex-1 flex flex-col justify-between sm:pl-4 pl-0" @click="openRateOrders">
        <p class="text-gray-700 font-semibold sm:text-sm text-xs whitespace-nowrap overflow-hidden text-ellipsis">Rate Your Order Experience</p>
  
        <div class="inline-flex items-center gap-1">
            <p class="text-gray-700 font-semibold sm:text-sm text-xs">{{ order.provider.name.length > 10 ? order.provider.name.slice(0, 10) + '...' : order.provider.name }}</p>
            <p class="text-xs sm:text-sm text-gray-600">{{ itemCount }} item(s)</p>
        </div>
      </div>
  
      <div class="flex flex-col justify-between items-center">
        <UButton color="primary" size="xs" label="Rate" block @click="openRatingForm" />
      </div>
  
      <div class="absolute -top-2 -right-2 sm:static sm:mr-2 flex-shrink-0 cursor-pointer bg-gray-200 sm:bg-transparent hover:bg-gray-300 sm:hover:bg-transparent rounded-full sm:p-1 p-2 shadow sm:shadow-none" @click="close(order)">
        <V3ImageComponent src="icons/close.png" class="h-3 w-3 sm:h-4 sm:w-4 filter grayscale" />
      </div>
    </div>
  </template>
  
<script setup>
import { V3ModalComponent, V3PopupComponent } from '#components';
  
const slideover = useSlideover();
const modal = useModal();
const { isMobile } = useDevice();
const emit = defineEmits(['close']);
const props = defineProps(['orders']);
const order = props.orders[0];
const auth = useAuth();
const { gtag } = useGtag();
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    }
  : {
      user_name: null,
      user_phone: null,
      user_email: null,
    };
const close = () => {
  emit('close', order);
  gtag('event', 'rating_popup_closed', {
    ...userData,
  });
}
const runtimeConfig = useRuntimeConfig() 
const setDefaultImage = (event) => {
  event.imageSrc = runtimeConfig.public.defaultProductImage;
}
const thumbnail = ref('');
onMounted(async () => {
  thumbnail.value = await useValidateThumbnailBuilder(order.provider.images);
});
const itemCount = order?.message?.order?.items?.length;
const openRateOrders = () => {
  if (isMobile) {
    slideover.open(V3PopupComponent, {
     component: "rating",
     data: props.orders,
     onClose: slideover.close,
    });
  } else {
    modal.open(V3ModalComponent, {
      component: "rating",
      data: props.orders,
      onClose: modal.close,
    });
  }
}

const openRatingForm = () => {
  if (isMobile) {
    slideover.open(V3PopupComponent, {
     component: "ratingForm",
     data: {orderData: order},
     onSuccess: () => {
      window.location.reload();
      slideover.close();
      },
     onClose: slideover.close,
    });
  } else {
    modal.open(V3ModalComponent, {
      component: "ratingForm",
      data: {orderData: order},
      onSuccess: () => {
        window.location.reload();
        modal.close();
      },
      onClose: modal.close,
    });
  }
  gtag("event", "cta_event", {
    action: "click",
    cta_name: "rating_cta_clicked",
    ...userData,
  });
}
</script>